import config from 'config';
import { useSelector } from 'react-redux';

import { selectUser } from '../reducers/user.selectors';
import { useAmplitudeExperiment } from './ampli';

// Unlike the corrections tool, no consumer needs "not answered yet": an unanswered
// flag hides the microphone exactly as a "no" does.
const useVoiceDictationEnabled = (): boolean => {
	const user = useSelector(selectUser);
	const { isReady, variant } = useAmplitudeExperiment(
		user,
		config.amplitudeExperiments.voiceDictation
	);

	return isReady && variant === 'on';
};

export default useVoiceDictationEnabled;
